import React from 'react';

import { IconProps } from './types';

const CircularAlertIcons: React.FC<IconProps> = props => {
  const { width = '24', height = '24', fillColor = 'var(--red-base)' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1Zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm1-3h-2v-2h2v2Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CircularAlertIcons;
